<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('purchaseRequest.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('purchaseRequest.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between ts-items-center ts-whitespace-no-wrap ts-space-x-3">
          <div class="ts-flex ts-items-center ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
            <a-range-picker v-model="dateRange" :allowClear="false" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"
              class="ts-w-64" @change="fetchData()" />
          </div>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <Tooltip :content="$t('purchaseRequest.search')" placement="top" transfer :max-width="width">
              <Input search v-model="search" :placeholder="$t('purchaseRequest.search')" :style="width"
                @on-focus="() => (width = 'width: 500px')" @on-blur="() => (width = 'width: 300px')" />
            </Tooltip>
            <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{ $t('employeeProfile.branch') }}</label>
                  <ts-branch-filter-v2 @filter="branchFilter" class="ts-w-full"></ts-branch-filter-v2>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <Table :columns="columns" :data="resources" size="small" :loading="loading" highlight-row stripe
        max-height="700">
        <template slot-scope="{ row }" slot="branch">
          {{ row.branch ? row.branch.branch_name_en : 'N/A' }}
        </template>
        <template slot-scope="{ row }" slot="pr_by_emp">
          {{ row.pr_by_emp ? row.pr_by_emp.employee_name_en : 'N/A' }}
        </template>
        <template slot-scope="{ row }" slot="project">
          {{ row.project ? row.project.project_name : 'N/A' }}
        </template>
        <template slot-scope="{ row }" slot="customer">
          {{ row.customer ? row.customer.customer_name : 'N/A' }}
        </template>
        <template slot-scope="{ row }" slot="approve_status">
          <span class="badge bg-secondary" v-if="row.approve_status == 0">
            {{ row.approve_status_name ? row.approve_status_name : 'N/A' }}
          </span>
          <span class="badge bg-info" v-if="row.approve_status == 1">
            {{ row.approve_status_name ? row.approve_status_name : 'N/A' }}
          </span>
          <span class="badge bg-success" v-if="row.approve_status == 2">
            {{ row.approve_status_name ? row.approve_status_name : 'N/A' }}
          </span>
          <span class="badge bg-danger" v-if="row.approve_status == 3">
            {{ row.approve_status_name ? row.approve_status_name : 'N/A' }}
          </span>
        </template>
        <template slot-scope="{ row }" slot="approved_by">
          {{ row.approved_by_user ? row.approved_by_user.employee_name_en : 'N/A' }}
        </template>
        <template slot-scope="{ row }" slot="create_by">
          {{ row.create_by ? row.create_by.employee_name_en : 'N/A' }}
        </template>
        <template slot-scope="{ row }" slot="action">
          <span class="ts-space-x-2">
            <a v-if="checkApproval(row)" href="#" v-tooltip="$t('confirm')"
              class="text-green" @click.prevent="confirm(row)">
              <i class="fas fa-check-circle"></i>
            </a>
            <a href="#" v-tooltip="$t('pdf')" class="text-red" @click.prevent="reprintReport(row)">
              <i class="fas fa-file-pdf"></i>
            </a>
            <a v-if="row.approve_status == 0" href="#" v-tooltip="$t('edit')" class="text-primary"
              @click.prevent="edit(row)">
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm v-if="row.approve_status == 0" placement="leftTop" :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')" :cancel-text="$t('no')" @confirm="deleteRecord(row)">
              <a href="#" :disabled="row._deleting">
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm>
          </span>
        </template>
      </Table>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-i-pagination v-model="pagination" @navigate="fetchData"></ts-i-pagination>
      </div>
      <!-- modal show pop-up pdf -->
      <a-modal v-model="show_pdf" :title="$t('pdf')" width="50%" :footer="null">
        <ts-preview-pdf v-model="waiting" :src="src" />
      </a-modal>

      <!-- modal show pop-up confirm purchase request -->
      <a-modal v-model="show_confirm" :title="$t('purchaseRequest.confirmTitle')" :footer="null" :zIndex="1020"
        :maskClosable="false" width="450px">
        <div>
          <div class="row">
            <div class="col-md-12">
              <label>
                {{ $t('purchaseRequest.comments') }} : </label>
              <textarea v-model="model_confirm.comments" rows="3" class="form-control ts-w-full"></textarea>
              <div class="validate" v-if="errors.has('comments')">
                {{ errors.first('comments') }}
              </div>
            </div>
          </div>
          <div class="row ts-mt-3">
            <div class="col-md-12 ts-flex ts-justify-end ts-space-x-3">
              <ts-button color="danger" class="ts-w-20" :waiting="waiting_confirm" @click.prevent="onConfirm(3)">
                {{ $t('reject') }}
              </ts-button>
              <ts-button color="primary" class="ts-w-20" :waiting="waiting_confirm" @click.prevent="onConfirm(2)">
                {{ $t('approve') }}
              </ts-button>
            </div>
          </div>
          <Spin size="large" fix v-if="waiting_confirm"></Spin>
        </div>
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'
import expandRow from './table-expand.vue'
import { Errors } from 'form-backend-validation'

export default {
  name: 'profileIndex',
  data() {
    return {
      loading: false,
      waiting: false,
      show_pdf: false,
      show_confirm: false,
      waiting_confirm: false,
      width: 'width: 300px',
      src: '',
      errors: new Errors(),
      model_confirm: {
        pr_main_id: null,
        approve_status: null,
        comments: '',
      }
    }
  },
  computed: {
    ...mapState('purchaseRequest/purchaseRequest', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.purchaseRequest.purchaseRequest.search
      },
      set(newValue) {
        this.$store.commit('purchaseRequest/purchaseRequest/SET_SEARCH', newValue)
        this.$store.commit('purchaseRequest/purchaseRequest/RESET_CURRENT_PAGE')
      }
    },
    dateRange: {
      get() {
        return this.$store.state.purchaseRequest.purchaseRequest.dateRange
      },
      set(newValue) {
        this.$store.commit('purchaseRequest/purchaseRequest/SET_DATE_RANGE', newValue)
      }
    },
    columns() {
      return [
        {
          type: 'expand',
          render: (h, params) => {
            return h(expandRow, {
              props: {
                row: params.row
              }
            })
          },
          width: 30
        },
        {
          title: this.$t('purchaseRequest.prDate'),
          key: 'pr_date',
          minWidth: 120,
          sortable: true
        },
        {
          title: this.$t('purchaseRequest.branchName'),
          slot: 'branch',
          minWidth: 140,
          sortable: true
        },
        {
          title: this.$t('purchaseRequest.prNumber'),
          key: 'pr_no',
          minWidth: 130,
          sortable: true
        },
        {
          title: this.$t('purchaseRequest.prBy'),
          slot: 'pr_by_emp',
          minWidth: 120,
          sortable: true
        },
        {
          title: this.$t('purchaseRequest.requiredDate'),
          key: 'required_date',
          minWidth: 140,
          sortable: true
        },
        {
          title: this.$t('purchaseRequest.project'),
          slot: 'project',
          minWidth: 120,
          sortable: true
        },
        {
          title: this.$t('purchaseRequest.customer'),
          slot: 'customer',
          minWidth: 120,
          sortable: true
        },
        {
          title: this.$t('purchaseRequest.approveStatus'),
          slot: 'approve_status',
          minWidth: 150,
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('purchaseRequest.approvedBy'),
          slot: 'approved_by',
          minWidth: 140,
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('purchaseRequest.createdBy'),
          slot: 'create_by',
          minWidth: 150,
          sortable: true
        },
        {
          title: this.$t('purchaseRequest.remarks'),
          key: 'remarks',
          minWidth: 200,
          sortable: true
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          minWidth: 110
        }
      ]
    }
  },
  methods: {
    ...mapActions('purchaseRequest/purchaseRequest', ['getFormViewModel']),
    branchFilter(value) {
      this.$store.commit('purchaseRequest/purchaseRequest/SET_BRANCH_ID', value)
      this.fetchData()
    },
    checkApproval(row) {
      const is_in_approval = row.approval_user.find(el => el.app_level == row.current_app_level && el.app_user_id == this.$store.state.authUser.user.user_id);
      if ([0, 1].includes(row.approve_status) && is_in_approval) {
        return true
      } else {
        return false
      }
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('purchaseRequest/purchaseRequest/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    confirm(row) {
      this.show_confirm = true
      this.model_confirm.pr_main_id = row.pr_main_id
    },
    onConfirm(approve_status) {
      this.model_confirm.approve_status = approve_status
      this.waiting_confirm = true
      this.errors = new Errors()
      this.$store
        .dispatch('purchaseRequest/purchaseRequest/confirm', {
          id: this.model_confirm.pr_main_id,
          data: this.model_confirm
        })
        .then(() => {
          this.show_confirm = false
          this.fetchData();
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_confirm = false
        })
    },
    addNew() {
      this.$router.push({ name: 'purchase-request-create' })
    },
    edit(record) {
      this.$router.push({
        name: 'purchase-request-edit',
        params: { id: record.pr_main_id }
      })
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('purchaseRequest/purchaseRequest/destroy', record.pr_main_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    reprintReport(record) {
      this.show_pdf = true
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('purchaseRequest/purchaseRequest/printPdf', record.pr_main_id)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
  },
  watch: {
    search: debounce(function () {
      this.fetchData()
    }, 500),
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('purchaseRequest/purchaseRequest/RESET_STATE')
    next()
  }
}
</script>
<style>
.ivu-input-with-suffix {
  height: 34px !important;
}
</style>
